import type { FlagMap } from './FlagsTypes'

const defaultFlags: FlagMap = {
  salesforce: {
    enabled: false,
    messageLogging: false,
  },
  contactNoteReactions: false,
  onboardingSubscriptionFraudTexts: false,
  sentry: false,
  sentryTracesSampleRate: 0,
  webSentryBrowserProfilingSampleRate: 0,
  webAdaChatBot: false,
  heap: false,
  messagingPolicyWarning: false,
  panelResizing: 'disabled',
  groupCallingListener: false,
  groupCallingWhispering: false,
  groupCallingAddMultipleParticipants: false,
  profilePageReferralCallout: false,
  minAutoChargeAmountCents: 0,
  callTranscripts: false,
  maxPinnableConversations: 0,
  downloadImageButton: false,
  phoneNumberPurchasing: { blocked: false },
  fetchContactsBatchLimit: 200,
  outageBanner: false,
  a2pStirShaken: false,
  disableCnamSubmissions: false,
  userIdleTimeout: 60_000,
  appAutoUpdateDelayMs: 600_000,
  webUserAudioSettings: false,
  contactTagFiltering: false,
  phoneNumberGroupMember: false,
  a2pBlockMessaging: false,
  tollFreeMessageBlocking: false,
  tollFreeFailedBackfill: false,
  webCallActivityClarity: false,
  viewers: false,
  webConversationLoadNewIndexedDBQuerying: false,
  webActivityStoreQueryIndexedDBQueryDirectly: false,
  trustCenterTollFree: false,
  webNoiseSuppression: false,
  webCallDetailsPanel: false,
  webSelfServeDataExport: false,
  callViews: false,
  webRecentHistory: false,
  webReEnableCnam: false,
  webCallQualityFeedbackSampleRate: 0,
  webCallQualityFeedback: false,
  webSurvicate: '',
  webPrivacyConsentImprovements: false,
  webNewDataLayerInboxCompanyFilterCombobox: false,
  webApiKeyGeneration: false,
  webAvalara: false,
  webLiveChatBadge: false,
  webWorkflowEngine: false,
  webUniversalLogin: false,
  webAiCallLabels: false,
  webUpdatedMemberInviteModal: false,
  webFirstRunInbox: false,
  webEnableA2P3DSPayments: false,
  webPhoneMenuInsights: false,
  webAiCallAssistantSettings: false,
  webSkyeAndAutomations: false,
  webCommandBarChecklist: false,
  webUniversalLoginCutOffDate: '',
  webParagonIntegrations: false,
  webParagonIntegrationsEnableJobberIntegration: false,
  webParagonIntegrationsMigration: false,
  webParagonIntegrationsLegacyToParagon: [],
  webEnableNativeJobberIntegration: false,
  webDisplayScaleTier: false,
  webCallDebugging: false,
  webWorkflowEngineStarterPlan: false,
  webDataDog: false,
  webDataDogSessionSampleRate: 0,
  webDataDogSessionReplaySampleRate: 0,
  webDataDogTraceSampleRate: 0,
  webContactsResyncId: '1970-01-01',
  webWorkflowAllowCreatingSingleRingUser: false,
  webWorkflowDisableOptOut: false,
  webCallFlowOnboarding: false,
  webUniversalLoginOffboardFromLegacyAuth: false,
  webAiAgentAnnouncement: false,
  webAiAgentDemoCTA: false,
  webUnlockedTrial: false,
  webDynamicRate: false,
  webCallRecordingNotification: false,
  webAiAgentKnowledgeV2: false,
  webOnboardingUnlockedTrial: false,
  webDecoupleCnam: false,
  webSonaTrial: false,
  webDesktopClientDeprecationDate: '',
  webImprovedUserMediaDeviceAccess: false,
  webEditInternalComments: false,
  webOnboardingReferralSource: false,
}

export default defaultFlags
